import getDocumentsForMarkers from '../getDocumentsForMarkers';
import getPercentageOfBookForDocuments from '../getPercentageOfBookForDocuments';

/**
 * Gets the total percentage of a book from a list of markers.
 * Currently uses the percentages of the underlying documents for this computation.
 *
 * @method getPercentageOfBookForMarkers
 * @param {Array<BookMarker>} markers - list of BookMarker objects
 * @returns {Number} a percentage of a book from 0 to 1
 */
const getPercentageOfBookForMarkers = (markers) => {
  return getPercentageOfBookForDocuments(getDocumentsForMarkers(markers));
};

export default getPercentageOfBookForMarkers;
